import { render } from "./QuoteEnterPostcode.vue?vue&type=template&id=daa8a10c&scoped=true&ts=true"
import script from "./QuoteEnterPostcode.vue?vue&type=script&lang=ts"
export * from "./QuoteEnterPostcode.vue?vue&type=script&lang=ts"

import "./QuoteEnterPostcode.vue?vue&type=style&index=0&id=daa8a10c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa8a10c"]])

export default __exports__